import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getTotalPayments} from '../actions';
import {Filters} from '../components';
import moment from 'moment';
import PaymentsOverviewTable from '../components/CustomTables/PaymentsOverviewTable';
import useFilters from '../utils/useFilters';
import {usePagination} from '../utils/utilities';
import {Box, Pagination} from '@mui/material';

const OverviewPayments = () => {
  const dispatch = useDispatch();
  const {paymentsLoading, totalPayments} = useSelector(s => s.payments);
  const filters = useFilters(val => dispatch(getTotalPayments(val)));
  const pagination = usePagination(totalPayments);

  useEffect(() => {
    dispatch(getTotalPayments());
  }, []);

  return (
    <>
      <Filters withBuilding withDateRange position="left" {...filters} />
      <PaymentsOverviewTable
        payments={pagination.dataToShow}
        loading={paymentsLoading}
      />
      {!!pagination.count && pagination.count > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination {...pagination} />
        </Box>
      )}
    </>
  );
};

export default OverviewPayments;
